import { render, staticRenderFns } from "./SaleInformation.vue?vue&type=template&id=03fc3fba&lang=pug&"
import script from "./SaleInformation.vue?vue&type=script&lang=js&"
export * from "./SaleInformation.vue?vue&type=script&lang=js&"
import style0 from "./SaleInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SaleInformation.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {
  VDivider,
  VFlex,
  VLayout,
  VToolbar,
  VToolbarTitle,
})
